import cn from 'classnames'
import React from 'react'

const WizardDateButton = ({
  icon,
  label,
  subtext,
  active,
  onClick,
  className,
}) => {
  const btnClassName = cn('wizard-date-button', {
    'wizard-date-button--active': active,
    [className]: className
  });

  return (
    <button
      className={btnClassName}
      onClick={onClick}
      >
      {icon}
      <span>{label}</span>
      <span className="wizard-date-button__subtext">{subtext}</span>
    </button>
  )
}

export default WizardDateButton
